import React, { useEffect, useMemo, useRef, useState } from "react";
import { Box, Button, Grid, Tab, Tabs, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { ArrowBackIos } from "@material-ui/icons";
import Dashbard from "../../Dashbard";
import Loader from "../../../../../components/common/Loader";
import { useDispatch } from "react-redux";
import { contactsTypesActions } from "../../../../../store/contactTypes/contactTypesActions";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import {
  AddressAutoComplete,
  Dropdown,
  EmptyTextArea,
  InputField,
} from "../../../../../components/common";
import { ValidatorForm } from "react-material-ui-form-validator";

const tabsConfig = [
  { id: "personalInfo", label: "Personal info" },
  { id: "contactInfo", label: "Contact info" },
  { id: "jobDetails", label: "Job details" },
  { id: "accountDetails", label: "Account details" },
  // { id: "education", label: "Education" },
  { id: "location", label: "Location" },
  { id: "links", label: "Links" },
  { id: "otherInfo", label: "Other info" },
  { id: "notes", label: "Notes" },
  { id: "customFields", label: "Custom fields" },
];

const genderOptions = [
  { id: "", name: "Not selected" },
  { id: "female", name: "Female" },
  { id: "male", name: "Male" },
  { id: "non_binary", name: "Non-binary" },
  { id: "prefer_not_to_say", name: "Prefer not to say" },
];

// const ownerOptions = [
//   { id: "bob_fils", name: "Bob Fils" },
//   { id: "alex_johnson", name: "Alex Johnson" },
//   { id: "rachel_green", name: "Rachel Green" },
// ];

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
].map(m => ({ id: m, name: m }));

const years = Array.from(
  { length: 61 },
  (_, idx) => `${new Date().getFullYear() - idx}`,
).map(y => ({ id: y, name: y }));

const accountTypes = [{ id: "prospect", name: "Prospect" }];

const timeZoneOptions = [
  "UTC-12:00",
  "UTC-08:00",
  "UTC-05:00",
  "UTC-03:00",
  "UTC+00:00",
  "UTC+01:00",
  "UTC+05:30",
  "UTC+08:00",
  "UTC+10:00",
].map(tz => ({ id: tz, name: tz }));

const requiredProspectFields = [
  "personalInfo.firstName",
  "personalInfo.lastName",
  "jobDetails.title",
  "accountDetails.companyName",
  "contactInfo.email",
];

const defaultProspectForm = {
  personalInfo: {
    firstName: "",
    lastName: "",
    middleName: "",
    nickname: "",
    gender: "",
    birthDate: "",
  },
  contactInfo: {
    email: "",
    phone: "",
    primaryEmail: "",
    primaryPhone: "",
  },
  jobDetails: {
    title: "",
    occupation: "",
    startMonth: "",
    startYear: "",
  },
  accountDetails: {
    type: accountTypes[0]?.id ?? "",
    companyName: "",
    numberOfEmployees: "",
    companyLinkedIn: "",
    companyLinkedInEmployees: "",
    companyFollowers: "",
    companyNaturalName: "",
    companyLocality: "",
  },
  education: {
    school: "",
    degree: "",
    graduationMonth: "",
    graduationYear: "",
  },
  location: {
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    region: "",
    timeZone: "",
  },
  links: {
    website: "",
    linkedin: "",
    twitter: "",
    facebook: "",
    instagram: "",
    other: "",
  },
  otherInfo: {
    source: "",
    onMarket: "",
    leadScore: "",
    campaignName: "",
  },
  notes: {
    personal: "",
    account: "",
    meeting: "",
    internal: "",
  },
  customFields: {
    custom1: "",
    custom2: "",
    custom3: "",
    custom4: "",
    custom5: "",
    custom6: "",
  },
};

const adaptIncomingDraft = draft => {
  if (!draft) return null;
  if (draft.personalInfo) return draft;
  return {
    personalInfo: {
      firstName: draft.firstName ?? "",
      lastName: draft.lastName ?? "",
      middleName: draft.middleName ?? "",
      nickname: draft.nickname ?? "",
      gender: draft.gender ?? "",
      birthDate: draft.birthDate ?? "",
    },
    contactInfo: {
      email: draft.email ?? "",
      phone: draft.phone ?? "",
      primaryEmail: draft.email ?? "",
      primaryPhone: draft.phone ?? "",
    },
    jobDetails: {
      title: draft.title ?? "",
      occupation: draft.occupation ?? "",
      startMonth: draft.startMonth ?? "",
      startYear: draft.startYear ?? "",
    },
    accountDetails: {
      type: draft.accountType ?? accountTypes[0]?.id ?? "",
      companyName: draft.company ?? "",
      numberOfEmployees: draft.numberOfEmployees ?? "",
      companyLinkedIn: draft.companyLinkedIn ?? "",
      companyLinkedInEmployees: draft.companyLinkedInEmployees ?? "",
      companyFollowers: draft.companyFollowers ?? "",
      companyNaturalName: draft.companyNaturalName ?? "",
      companyLocality: draft.companyLocality ?? "",
    },
    education: {
      school: draft.school ?? "",
      degree: draft.degree ?? "",
      graduationMonth: draft.graduationMonth ?? "",
      graduationYear: draft.graduationYear ?? "",
    },
    location: {
      address1: draft.address1 ?? "",
      address2: draft.address2 ?? "",
      city: draft.city ?? "",
      state: draft.state ?? "",
      zip: draft.zip ?? "",
      country: draft.country ?? "",
      region: draft.region ?? "",
      timeZone: draft.timeZone ?? "",
    },
    links: {
      website: draft.website ?? "",
      linkedin: draft.linkedin ?? "",
      twitter: draft.twitter ?? "",
      facebook: draft.facebook ?? "",
      instagram: draft.instagram ?? "",
      other: draft.otherLinks ?? "",
    },
    otherInfo: {
      source: draft.source ?? "",
      onMarket: draft.onMarket ?? "",
      leadScore: draft.leadScore ?? "",
      campaignName: draft.campaignName ?? "",
    },
    notes: {
      personal: draft.personalNotes ?? draft.notes ?? "",
      account: draft.accountNotes ?? "",
      meeting: draft.meetingNotes ?? "",
      internal: draft.internalNotes ?? "",
    },
    customFields: {
      custom1: draft.customField1 ?? "",
      custom2: draft.customField2 ?? "",
      custom3: draft.customField3 ?? "",
      custom4: draft.customField4 ?? "",
      custom5: draft.customField5 ?? "",
      custom6: draft.customField6 ?? "",
    },
  };
};

const deepMerge = (base, source) => {
  if (!source) return JSON.parse(JSON.stringify(base));
  if (Array.isArray(base)) return source ? [...source] : [...base];
  const result = { ...base };
  Object.keys(base).forEach(key => {
    if (typeof base[key] === "object" && base[key] !== null) {
      result[key] = deepMerge(base[key], source[key]);
    } else {
      result[key] =
        typeof source[key] !== "undefined" ? source[key] : base[key];
    }
  });
  return result;
};

const normaliseInitialData = incomingData => {
  const draft = adaptIncomingDraft(incomingData) ?? defaultProspectForm;
  return deepMerge(defaultProspectForm, draft);
};

const getByPath = (obj, path) =>
  path
    .split(".")
    .reduce(
      (acc, key) => (acc && acc.hasOwnProperty(key) ? acc[key] : undefined),
      obj,
    );

const setByPath = (obj, path, value) => {
  const keys = path.split(".");
  const lastKey = keys.pop();
  const target = keys.reduce((acc, key) => {
    if (typeof acc[key] === "undefined") acc[key] = {};
    return acc[key];
  }, obj);
  target[lastKey] = value;
};

const cloneFormData = data => JSON.parse(JSON.stringify(data));

const useStyles = makeStyles(theme => ({
  headingContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.5),
    alignItems: "flex-start",
  },
  backButton: {
    textTransform: "none",
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
  contentCard: {
    marginTop: theme.spacing(3),
    backgroundColor: "#fff",
    borderRadius: 16,
    padding: theme.spacing(3),
    boxShadow: "0px 12px 24px rgba(15, 20, 34, 0.08)",
  },
  tabLayout: {
    display: "flex",
    gap: theme.spacing(4),
    [theme.breakpoints.down("sm")]: { flexDirection: "column" },
  },
  tabsRoot: {
    minWidth: 200,
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  tabRoot: {
    justifyContent: "flex-start",
    alignItems: "flex-start",
    textTransform: "none",
    fontWeight: 500,
    fontSize: 14,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  tabSelected: {
    color: `${theme.palette.primary.main} !important`,
    fontWeight: 600,
  },
  tabIndicator: {
    left: 0,
    width: 3,
    borderRadius: 3,
    backgroundColor: theme.palette.primary.main,
  },
  tabPanel: { flex: 1 },
  sectionHeading: {
    fontWeight: 600,
    fontSize: 18,
    marginBottom: theme.spacing(3),
  },
  actions: {
    marginTop: theme.spacing(4),
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(2),
  },
  cancelButton: { textTransform: "none !important" },
}));

const TabPanel = ({ children, value, index }) => (
  <div
    role='tabpanel'
    hidden={value !== index}
    id={`new-prospect-tabpanel-${index}`}
    aria-labelledby={`new-prospect-tab-${index}`}>
    {value === index ? <Box>{children}</Box> : null}
  </div>
);

const NewProspectGeneration = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { id } = useParams();
  const locationState = location?.state;
  const locationDraft = useMemo(
    () => locationState?.prospectDraft ?? null,
    [locationState],
  );

  const [isLoading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  const [formData, setFormData] = useState(() =>
    cloneFormData(normaliseInitialData(locationDraft)),
  );
  const formDataRef = useRef(formData);
  const initialFormRef = useRef(
    cloneFormData(normaliseInitialData(locationDraft)),
  );
  const formRef = useRef(null);
  const todayISO = () => new Date().toISOString().split("T")[0];

  useEffect(() => {
    if (id) {
      console.log("Prospect ID:", id);
      setLoading(true);
      dispatch(contactsTypesActions.onGetProspectById(id))
        .then(data => {
          setLoading(false);
          if (data?.success) {
            const apiData = data.data;
            const adaptedFormData = {
              personalInfo: {
                firstName: apiData.firstName || "",
                lastName: apiData.lastName || "",
                middleName: "", // Not in API response
                nickname: apiData.nickName || "",
                gender: "", // Not in API response
                birthDate: apiData.dob || "",
              },
              contactInfo: {
                email: apiData.email || "",
                phone: apiData.contactNo || "",
                primaryEmail: apiData.email || "",
                primaryPhone: apiData.contactNo || "",
              },
              jobDetails: {
                title: apiData.title || "",
                occupation: apiData.occupation || "",
                startMonth: apiData.startMonth || "",
                startYear: apiData.startYear || "",
              },
              accountDetails: {
                type: accountTypes[0]?.id || "", // Default to first account type
                companyName: apiData.companyName || "",
                numberOfEmployees: apiData.noOfEmployees?.toString() || "",
                companyLinkedIn: apiData.companyLinkeding || "",
                companyLinkedInEmployees:
                  apiData.companyLinkedinEmployees?.toString() || "",
                companyFollowers: apiData.companyFollowers?.toString() || "",
                companyNaturalName: apiData.companyNaturalName || "",
                companyLocality: apiData.companyLocality || "",
              },
              education: {
                school: "", // Not in API response
                degree: "", // Not in API response
                graduationMonth: "", // Not in API response
                graduationYear: "", // Not in API response
              },
              location: {
                address1: apiData.address1 || "",
                address2: apiData.address2 || "",
                city: apiData.city || "",
                state: apiData.state || "",
                zip: apiData.zipCode || "",
                country: apiData.country || "",
                region: apiData.region || "",
                timeZone: apiData.timezone || "",
              },
              links: {
                website: apiData.website || "",
                linkedin: apiData.linkedin || "",
                twitter: apiData.twitter || "",
                facebook: apiData.facebook || "",
                instagram: apiData.instagram || "",
                other: apiData.other || "",
              },
              otherInfo: {
                source: apiData.source || "",
                onMarket: apiData.onMarket || "",
                leadScore: apiData.leadScore?.toString() || "",
                campaignName: apiData.campaign || "",
              },
              notes: {
                personal: apiData.personalNotes || "",
                account: apiData.accountNotes || "",
                meeting: apiData.meetingNotes || "",
                internal: apiData.internalNotes || "",
              },
              customFields: {
                custom1: apiData.cusomField1 || "", // Note: typo in API response "cusomField1"
                custom2: apiData.cusomField2 || "",
                custom3: apiData.cusomField3 || "",
                custom4: apiData.cusomField4 || "",
                custom5: apiData.cusomField5 || "",
                custom6: apiData.cusomField6 || "",
              },
            };

            // Set the form data with the adapted API response
            setFormData(adaptedFormData);
            formDataRef.current = adaptedFormData;

            // Also update the initial form reference for "Clear Changes" functionality
            initialFormRef.current = cloneFormData(adaptedFormData);
          } else {
            // Handle API error
            toast.error(data?.message || "Failed to load prospect data");
          }
        })
        .catch(error => {
          setLoading(false);
          toast.error("Error loading prospect data");
          console.error("Error fetching prospect:", error);
        });
    }
  }, [id]);

  useEffect(() => {
    ValidatorForm.addValidationRule("isPrimaryEmailPresent", () => {
      const email = getByPath(formDataRef.current, "contactInfo.email") || "";
      return !!email?.trim();
    });
    ValidatorForm.addValidationRule("isOptionalEmailOrEmpty", value => {
      if (!value) return true;
      const re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\.,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,})$/i;
      return re.test(value);
    });
    ValidatorForm.addValidationRule("isNotFutureDate", value => {
      if (!value) return true;
      return value <= todayISO();
    });
    return () => {
      ValidatorForm.removeValidationRule?.("isNotFutureDate");
    };
  }, []);

  useEffect(() => {
    const normalized = normaliseInitialData(locationDraft);
    initialFormRef.current = cloneFormData(normalized);
    setFormData(normalized);
    formDataRef.current = normalized;
  }, [locationDraft]);

  const setValue = (path, value) => {
    setFormData(prev => {
      const updated = cloneFormData(prev);
      setByPath(updated, path, value);
      formDataRef.current = updated;
      return updated;
    });
  };

  const requiredPathsFilled = () =>
    requiredProspectFields.every(p => {
      const v = getByPath(formDataRef.current, p);
      return typeof v === "string" ? v.trim().length > 0 : !!v;
    });

  const requiredByTab = {
    0: [{ path: "personalInfo.firstName", el: "pi-firstname" }],
    1: [
      { path: "contactInfo.email", el: "ci-email" },
      { path: "contactInfo.phone", el: "ci-phone" },
    ],
    2: [],
    3: [{ path: "accountDetails.companyName", el: "ad-company" }],
  };

  const handleTabChange = (_, newValue) => {
    // If moving backward (to a lower index), allow it without validation
    if (newValue < activeTab) {
      setActiveTab(newValue);
      return;
    }
    // Only validate when moving forward (to a higher index)
    const reqs = requiredByTab[activeTab] || [];
    const invalidField = reqs.find(({ path }) => {
      const value = getByPath(formDataRef.current, path);
      if (!value || (typeof value === "string" && !value.trim())) return true;

      if (path.includes("email")) {
        const re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\.,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,})$/i;
        return !re.test(value.trim());
      }

      if (path.includes("firstName")) {
        const nameRegex = /^[A-Za-z']+(?: [A-Za-z']+)*$/;
        return !nameRegex.test(value.trim());
      }

      return false;
    });

    if (!invalidField) {
      setActiveTab(newValue);
      return;
    }

    const el = document.getElementById(invalidField.el);
    if (el?.focus) el.focus();

    let errorMsg =
      "Please complete the required fields on this tab before continuing.";

    if (invalidField.path.includes("email"))
      errorMsg = "Please provide a valid email address before moving ahead.";
    else if (
      invalidField.path.includes("firstName") ||
      invalidField.path.includes("lastName")
    )
      errorMsg =
        "First name and Last name must only contain alphabets and cannot include spaces or special characters.";

    toast.error(errorMsg);
  };

  const handleClear = () => {
    const resetForm = cloneFormData(initialFormRef.current);
    setFormData(resetForm);
    formDataRef.current = resetForm;
  };

  const handleSave = () => {
    const prospectPayload = {
      ...(id && { id: parseInt(id) }),
      firstName: formData?.personalInfo?.firstName,
      lastName: formData?.personalInfo?.lastName,
      email: formData?.contactInfo?.email || "",
      contactNo: formData?.contactInfo?.phone || "",
      nickName: formData?.personalInfo?.nickname,
      dob: formData?.personalInfo?.birthDate,
      title: formData?.jobDetails?.title,
      occupation: formData?.jobDetails?.occupation,
      startMonth: formData?.jobDetails?.startMonth,
      startYear: formData?.jobDetails?.startYear,
      companyName: formData?.accountDetails?.companyName,
      noOfEmployees: parseInt(formData?.accountDetails?.numberOfEmployees) || 0,
      companyLinkeding: formData?.accountDetails?.companyLinkedIn,
      companyLinkedinEmployees:
        parseInt(formData?.accountDetails?.companyLinkedInEmployees) || 0,
      companyFollowers:
        parseInt(formData?.accountDetails?.companyFollowers) || 0,
      companyNaturalName: formData?.accountDetails?.companyNaturalName,
      companyLocality: formData?.accountDetails?.companyLocality,
      address1: formData?.location?.address1,
      city: formData?.location?.city,
      state: formData?.location?.state,
      region: formData?.location?.region,
      country: formData?.location?.country,
      zipCode: formData?.location?.zip,
      timezone: formData?.location?.timeZone,
      website: formData?.links?.website,
      linkedin: formData?.links?.linkedin,
      twitter: formData?.links?.twitter,
      facebook: formData?.links?.facebook,
      instagram: formData?.links?.instagram,
      other: formData?.links?.other,
      source: formData?.otherInfo?.source,
      onMarket: formData?.otherInfo?.onMarket,
      leadScore: parseInt(formData?.otherInfo?.leadScore) || 0,
      campaign: formData?.otherInfo?.campaignName,
      personalNotes: formData?.notes?.personal,
      accountNotes: formData?.notes?.account,
      meetingNotes: formData?.notes?.meeting,
      internalNotes: formData?.notes?.internal,
      cusomField1: formData?.customFields?.custom1,
      cusomField2: formData?.customFields?.custom2,
      cusomField3: formData?.customFields?.custom3,
      cusomField4: formData?.customFields?.custom4,
      cusomField5: formData?.customFields?.custom5,
      cusomField6: formData?.customFields?.custom6,
    };
    setLoading(true);
    dispatch(contactsTypesActions.onAddProspect(prospectPayload)).then(data => {
      setLoading(false);
      if (data?.data?.success) {
        history.push("/prospect-generation");
      } else {
        toast.error(data?.data?.message);
      }
    });
  };

  const handleAddListItem = (path, def = "") =>
    setFormData(prev => {
      const updated = cloneFormData(prev);
      const list = getByPath(updated, path) || [];
      setByPath(updated, path, [...list, def]);
      formDataRef.current = updated;
      return updated;
    });

  const handleRemoveListItem = (path, index) =>
    setFormData(prev => {
      const updated = cloneFormData(prev);
      const list = getByPath(updated, path) || [];
      if (list.length <= 1) setByPath(updated, path, [""]);
      else
        setByPath(
          updated,
          path,
          list.filter((_, i) => i !== index),
        );
      formDataRef.current = updated;
      return updated;
    });

  const handleListItemChange = (path, index, value) =>
    setFormData(prev => {
      const updated = cloneFormData(prev);
      const list = getByPath(updated, path) || [];
      const next = [...list];
      next[index] = value;
      setByPath(updated, path, next);
      formDataRef.current = updated;
      return updated;
    });

  return (
    <Dashbard>
      <div className='body-content'>
        {isLoading ? <Loader /> : null}
        <div className={`contentHeading ${classes.headingContainer}`}>
          <h1>{id ? "Edit Prospect" : "New Prospect"}</h1>
          <Button
            className={classes.backButton}
            color='primary'
            onClick={() => history.push("/prospect-generation")}>
            <ArrowBackIos style={{ fontSize: 14, marginRight: 6 }} />
            Back to Prospects
          </Button>
        </div>

        <div className={classes.contentCard}>
          <ValidatorForm onSubmit={handleSave} ref={formRef} instantValidate>
            <div className={classes.tabLayout}>
              <Tabs
                orientation='vertical'
                value={activeTab}
                onChange={handleTabChange}
                classes={{
                  root: classes.tabsRoot,
                  indicator: classes.tabIndicator,
                }}>
                {tabsConfig.map((tab, index) => (
                  <Tab
                    key={tab.id}
                    label={tab.label}
                    id={`new-prospect-tab-${index}`}
                    aria-controls={`new-prospect-tabpanel-${index}`}
                    classes={{
                      root: classes.tabRoot,
                      selected: classes.tabSelected,
                    }}
                  />
                ))}
              </Tabs>

              <div className={classes.tabPanel}>
                {/* Personal info */}
                <TabPanel value={activeTab} index={0}>
                  <Typography className={classes.sectionHeading}>
                    Personal info
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='First name'
                        inputlabel='First name'
                        id='pi-firstname'
                        name='pi-firstname'
                        value={getByPath(formData, "personalInfo.firstName")}
                        onChange={e =>
                          setValue("personalInfo.firstName", e.target.value)
                        }
                        showRequired
                        validators={[
                          "required",
                          "matchRegexp:^[A-Za-z']+(?: [A-Za-z']+)*$",
                          "matchRegexp:^.{0,50}$",
                        ]}
                        errorMessages={[
                          "This field is required",
                          "Only letters, apostrophes and spaces between words are allowed",
                          "Maximum length is 50 characters",
                        ]}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='Last name'
                        inputlabel='Last name'
                        id='pi-lastname'
                        name='pi-lastname'
                        value={getByPath(formData, "personalInfo.lastName")}
                        onChange={e =>
                          setValue("personalInfo.lastName", e.target.value)
                        }
                        validators={[
                          "matchRegexp:^[A-Za-z']+(?: [A-Za-z']+)*$",
                          "matchRegexp:^.{0,50}$",
                        ]}
                        errorMessages={[
                          "Only letters, apostrophes and spaces between words are allowed",
                          "Maximum length is 50 characters",
                        ]}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='Middle name'
                        inputlabel='Middle name'
                        id='pi-middlename'
                        name='pi-middlename'
                        value={getByPath(formData, "personalInfo.middleName")}
                        onChange={e =>
                          setValue("personalInfo.middleName", e.target.value)
                        }
                        validators={["matchRegexp:^.{0,50}$"]}
                        errorMessages={["Maximum length is 50 characters"]}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='Nickname'
                        inputlabel='Nickname'
                        id='pi-nickname'
                        name='pi-nickname'
                        value={getByPath(formData, "personalInfo.nickname")}
                        onChange={e =>
                          setValue("personalInfo.nickname", e.target.value)
                        }
                        validators={["matchRegexp:^.{0,50}$"]}
                        errorMessages={["Maximum length is 50 characters"]}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Dropdown
                        selectlabel='Gender'
                        placeholder='Please Select'
                        value={getByPath(formData, "personalInfo.gender")}
                        customMenuItems={genderOptions}
                        required={false}
                        handleChange={({ target }) =>
                          setValue("personalInfo.gender", target.value)
                        }
                      />
                    </Grid>

                    {/* <Grid item xs={12} md={6}>
                      <InputField
                        placeholder="Birth date"
                        inputlabel="Birth date"
                        type="date"
                        value={getByPath(formData, "personalInfo.birthDate")}
                        onChange={e => setValue("personalInfo.birthDate", e.target.value)}
                        validators={["isNotFutureDate"]}
                        errorMessages={["Birth date cannot be in the future"]}
                        inputProps={{ max: todayISO() }}
                      />
                    </Grid> */}

                    {/* <Grid item xs={12} md={6}>
                      <Dropdown
                        selectlabel="Owner"
                        placeholder="Please Select"
                        value={getByPath(formData, "personalInfo.owner")}
                        customMenuItems={ownerOptions}
                        required={false}
                        handleChange={({ target }) => setValue("personalInfo.owner", target.value)}
                      />
                    </Grid> */}
                  </Grid>
                </TabPanel>

                {/* Contact info */}
                <TabPanel value={activeTab} index={1}>
                  <Typography className={classes.sectionHeading}>
                    Contact info
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='Email address'
                        inputlabel='Email'
                        id='ci-email'
                        name='ci-email'
                        value={getByPath(formData, "contactInfo.email") || ""}
                        onChange={e =>
                          setValue("contactInfo.email", e.target.value)
                        }
                        showRequired
                        validators={[
                          "required",
                          "isPrimaryEmailPresent",
                          "isEmail",
                          "matchRegexp:^.{0,100}$",
                        ]}
                        errorMessages={[
                          "This field is required",
                          "Email is required",
                          "Email is not valid",
                          "Maximum length is 100 characters",
                        ]}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='Phone number'
                        inputlabel='Phone'
                        id='ci-phone'
                        name='ci-phone'
                        value={getByPath(formData, "contactInfo.phone") || ""}
                        onChange={e =>
                          setValue("contactInfo.phone", e.target.value)
                        }
                        showRequired
                        validators={[
                          "required",
                          "matchRegexp:^\\+?[0-9]*$",
                          "matchRegexp:^.{0,20}$",
                        ]}
                        errorMessages={[
                          "This field is required",
                          "Not valid number",
                          "Maximum length is 20 characters",
                        ]}
                      />
                    </Grid>
                  </Grid>
                </TabPanel>

                {/* Job details */}
                <TabPanel value={activeTab} index={2}>
                  <Typography className={classes.sectionHeading}>
                    Job details
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='Title'
                        inputlabel='Title'
                        id='jd-title'
                        name='jd-title'
                        value={getByPath(formData, "jobDetails.title")}
                        onChange={e =>
                          setValue("jobDetails.title", e.target.value)
                        }
                        validators={["matchRegexp:^.{0,100}$"]}
                        errorMessages={["Maximum length is 100 characters"]}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='Occupation'
                        inputlabel='Occupation'
                        id='jd-occupation'
                        name='jd-occupation'
                        value={getByPath(formData, "jobDetails.occupation")}
                        onChange={e =>
                          setValue("jobDetails.occupation", e.target.value)
                        }
                        validators={["matchRegexp:^.{0,100}$"]}
                        errorMessages={["Maximum length is 100 characters"]}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Dropdown
                        selectlabel='Start month'
                        placeholder='Select'
                        value={getByPath(formData, "jobDetails.startMonth")}
                        customMenuItems={[
                          { id: "", name: "Select" },
                          ...months,
                        ]}
                        required={false}
                        handleChange={({ target }) =>
                          setValue("jobDetails.startMonth", target.value)
                        }
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Dropdown
                        selectlabel='Start year'
                        placeholder='Select'
                        value={getByPath(formData, "jobDetails.startYear")}
                        customMenuItems={[{ id: "", name: "Select" }, ...years]}
                        required={false}
                        handleChange={({ target }) =>
                          setValue("jobDetails.startYear", target.value)
                        }
                      />
                    </Grid>
                  </Grid>
                </TabPanel>

                {/* Account details */}
                <TabPanel value={activeTab} index={3}>
                  <Typography className={classes.sectionHeading}>
                    Account details
                  </Typography>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <Dropdown
                        selectlabel='Account type'
                        placeholder='Please Select'
                        value={getByPath(formData, "accountDetails.type")}
                        customMenuItems={accountTypes}
                        required={false}
                        handleChange={({ target }) =>
                          setValue("accountDetails.type", target.value)
                        }
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='Company name'
                        inputlabel='Company name'
                        id='ad-company'
                        name='ad-company'
                        value={getByPath(
                          formData,
                          "accountDetails.companyName",
                        )}
                        onChange={e =>
                          setValue("accountDetails.companyName", e.target.value)
                        }
                        showRequired
                        validators={["required", "matchRegexp:^.{0,100}$"]}
                        errorMessages={[
                          "This field is required",
                          "Maximum length is 100 characters",
                        ]}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='Number of employees'
                        inputlabel='Number of employees'
                        id='ad-employees'
                        name='ad-employees'
                        type={"number"}
                        value={getByPath(
                          formData,
                          "accountDetails.numberOfEmployees",
                        )}
                        onChange={e =>
                          setValue(
                            "accountDetails.numberOfEmployees",
                            e.target.value,
                          )
                        }
                        validators={[
                          "matchRegexp:^[0-9]*$",
                          "matchRegexp:^.{0,10}$",
                        ]}
                        errorMessages={[
                          "Only digits allowed",
                          "Maximum length is 10 characters",
                        ]}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='Company LinkedIn'
                        inputlabel='Company LinkedIn'
                        id='ad-linkedin'
                        name='ad-linkedin'
                        value={getByPath(
                          formData,
                          "accountDetails.companyLinkedIn",
                        )}
                        onChange={e =>
                          setValue(
                            "accountDetails.companyLinkedIn",
                            e.target.value,
                          )
                        }
                        validators={["matchRegexp:^.{0,150}$"]}
                        errorMessages={["Maximum length is 150 characters"]}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='Company LinkedIn employees'
                        inputlabel='Company LinkedIn employees'
                        id='ad-linkedin-emps'
                        name='ad-linkedin-emps'
                        type={"number"}
                        value={getByPath(
                          formData,
                          "accountDetails.companyLinkedInEmployees",
                        )}
                        onChange={e =>
                          setValue(
                            "accountDetails.companyLinkedInEmployees",
                            e.target.value,
                          )
                        }
                        validators={[
                          "matchRegexp:^[0-9]*$",
                          "matchRegexp:^.{0,10}$",
                        ]}
                        errorMessages={[
                          "Only digits allowed",
                          "Maximum length is 10 characters",
                        ]}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='Company followers'
                        inputlabel='Company followers'
                        id='ad-followers'
                        name='ad-followers'
                        type={"number"}
                        value={getByPath(
                          formData,
                          "accountDetails.companyFollowers",
                        )}
                        onChange={e =>
                          setValue(
                            "accountDetails.companyFollowers",
                            e.target.value,
                          )
                        }
                        validators={[
                          "matchRegexp:^[0-9]*$",
                          "matchRegexp:^.{0,10}$",
                        ]}
                        errorMessages={[
                          "Only digits allowed",
                          "Maximum length is 10 characters",
                        ]}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='Company natural name'
                        inputlabel='Company natural name'
                        id='ad-natural'
                        name='ad-natural'
                        value={getByPath(
                          formData,
                          "accountDetails.companyNaturalName",
                        )}
                        onChange={e =>
                          setValue(
                            "accountDetails.companyNaturalName",
                            e.target.value,
                          )
                        }
                        validators={["matchRegexp:^.{0,100}$"]}
                        errorMessages={["Maximum length is 100 characters"]}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='Company locality'
                        inputlabel='Company locality'
                        id='ad-locality'
                        name='ad-locality'
                        value={getByPath(
                          formData,
                          "accountDetails.companyLocality",
                        )}
                        onChange={e =>
                          setValue(
                            "accountDetails.companyLocality",
                            e.target.value,
                          )
                        }
                        validators={["matchRegexp:^.{0,100}$"]}
                        errorMessages={["Maximum length is 100 characters"]}
                      />
                    </Grid>
                  </Grid>
                </TabPanel>

                {/* Education */}
                {/* <TabPanel value={activeTab} index={4}>
                  <Typography className={classes.sectionHeading}>
                    Education
                  </Typography>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='School'
                        inputlabel='School'
                        id='edu-school'
                        name='edu-school'
                        value={getByPath(formData, "education.school")}
                        onChange={e =>
                          setValue("education.school", e.target.value)
                        }
                        validators={["matchRegexp:^.{0,100}$"]}
                        errorMessages={["Maximum length is 100 characters"]}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='Degree'
                        inputlabel='Degree'
                        id='edu-degree'
                        name='edu-degree'
                        value={getByPath(formData, "education.degree")}
                        onChange={e =>
                          setValue("education.degree", e.target.value)
                        }
                        validators={["matchRegexp:^.{0,100}$"]}
                        errorMessages={["Maximum length is 100 characters"]}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Dropdown
                        selectlabel='Graduation month'
                        placeholder='Select'
                        value={getByPath(formData, "education.graduationMonth")}
                        customMenuItems={[
                          { id: "", name: "Select" },
                          ...months,
                        ]}
                        required={false}
                        handleChange={({ target }) =>
                          setValue("education.graduationMonth", target.value)
                        }
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Dropdown
                        selectlabel='Graduation year'
                        placeholder='Select'
                        value={getByPath(formData, "education.graduationYear")}
                        customMenuItems={[{ id: "", name: "Select" }, ...years]}
                        required={false}
                        handleChange={({ target }) =>
                          setValue("education.graduationYear", target.value)
                        }
                      />
                    </Grid>
                  </Grid>
                </TabPanel> */}

                {/* Location */}
                <TabPanel value={activeTab} index={4}>
                  <Typography className={classes.sectionHeading}>
                    Location
                  </Typography>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <AddressAutoComplete
                        autoComId='prospectAddressAutoComplete'
                        address={getByPath(formData, "location.address1")}
                        label='Address'
                        onChange={e =>
                          setValue("location.address1", e.target.value)
                        }
                        setPlace={place => {
                          let city = "",
                            state = "",
                            country = "",
                            postalCode = "",
                            region = "",
                            address = "";
                          place?.address_components?.forEach(x => {
                            if (x?.types?.includes("route")) {
                              address = x?.long_name;
                            }
                            if (x.types?.includes("locality"))
                              city = x.long_name;
                            if (
                              x.types?.includes("administrative_area_level_1")
                            )
                              state = x.long_name;
                            if (x.types?.includes("country"))
                              country = x.long_name;
                            if (x.types?.includes("postal_code"))
                              postalCode = x.long_name;
                            if (
                              x.types?.includes("administrative_area_level_2")
                            )
                              region = x.long_name;
                          });

                          // Update form values
                          setValue("location.address1", address);
                          setValue("location.city", city);
                          setValue("location.state", state);
                          setValue("location.country", country);
                          setValue("location.zip", postalCode);
                          setValue("location.region", region);
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='City'
                        inputlabel='City'
                        id='loc-city'
                        name='loc-city'
                        value={getByPath(formData, "location.city")}
                        onChange={e =>
                          setValue("location.city", e.target.value)
                        }
                        validators={["matchRegexp:^.{0,100}$"]}
                        errorMessages={["Maximum length is 100 characters"]}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <InputField
                        placeholder='State'
                        inputlabel='State'
                        id='loc-state'
                        name='loc-state'
                        value={getByPath(formData, "location.state")}
                        onChange={e =>
                          setValue("location.state", e.target.value)
                        }
                        validators={["matchRegexp:^.{0,50}$"]}
                        errorMessages={["Maximum length is 50 characters"]}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <InputField
                        placeholder='ZIP'
                        inputlabel='ZIP'
                        id='loc-zip'
                        name='loc-zip'
                        value={getByPath(formData, "location.zip")}
                        onChange={e => setValue("location.zip", e.target.value)}
                        validators={[
                          "matchRegexp:^(?:[A-Z0-9a-z ]+([-_ ]?[A-Z0-9a-z]+)*)?$",
                          "matchRegexp:^.{0,15}$",
                        ]}
                        errorMessages={[
                          "Special characters and multiple spaces are not allowed",
                          "Maximum length is 15 characters",
                        ]}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='Country'
                        inputlabel='Country'
                        id='loc-country'
                        name='loc-country'
                        value={getByPath(formData, "location.country")}
                        onChange={e =>
                          setValue("location.country", e.target.value)
                        }
                        validators={["matchRegexp:^.{0,100}$"]}
                        errorMessages={["Maximum length is 100 characters"]}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='Region'
                        inputlabel='Region'
                        id='loc-region'
                        name='loc-region'
                        value={getByPath(formData, "location.region")}
                        onChange={e =>
                          setValue("location.region", e.target.value)
                        }
                        validators={["matchRegexp:^.{0,100}$"]}
                        errorMessages={["Maximum length is 100 characters"]}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Dropdown
                        selectlabel='Time zone'
                        placeholder='Select'
                        value={getByPath(formData, "location.timeZone")}
                        customMenuItems={[
                          { id: "", name: "Select" },
                          ...timeZoneOptions,
                        ]}
                        required={false}
                        handleChange={({ target }) =>
                          setValue("location.timeZone", target.value)
                        }
                      />
                    </Grid>
                  </Grid>
                </TabPanel>

                {/* Links */}
                <TabPanel value={activeTab} index={5}>
                  <Typography className={classes.sectionHeading}>
                    Links
                  </Typography>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='Website'
                        inputlabel='Website'
                        id='ln-website'
                        name='ln-website'
                        value={getByPath(formData, "links.website")}
                        onChange={e =>
                          setValue("links.website", e.target.value)
                        }
                        validators={["matchRegexp:^.{0,150}$"]}
                        errorMessages={["Maximum length is 150 characters"]}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='LinkedIn'
                        inputlabel='LinkedIn'
                        id='ln-linkedin'
                        name='ln-linkedin'
                        value={getByPath(formData, "links.linkedin")}
                        onChange={e =>
                          setValue("links.linkedin", e.target.value)
                        }
                        validators={["matchRegexp:^.{0,150}$"]}
                        errorMessages={["Maximum length is 150 characters"]}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='Twitter'
                        inputlabel='Twitter'
                        id='ln-twitter'
                        name='ln-twitter'
                        value={getByPath(formData, "links.twitter")}
                        onChange={e =>
                          setValue("links.twitter", e.target.value)
                        }
                        validators={["matchRegexp:^.{0,150}$"]}
                        errorMessages={["Maximum length is 150 characters"]}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='Facebook'
                        inputlabel='Facebook'
                        id='ln-facebook'
                        name='ln-facebook'
                        value={getByPath(formData, "links.facebook")}
                        onChange={e =>
                          setValue("links.facebook", e.target.value)
                        }
                        validators={["matchRegexp:^.{0,150}$"]}
                        errorMessages={["Maximum length is 150 characters"]}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='Instagram'
                        inputlabel='Instagram'
                        id='ln-instagram'
                        name='ln-instagram'
                        value={getByPath(formData, "links.instagram")}
                        onChange={e =>
                          setValue("links.instagram", e.target.value)
                        }
                        validators={["matchRegexp:^.{0,150}$"]}
                        errorMessages={["Maximum length is 150 characters"]}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='Other'
                        inputlabel='Other'
                        id='ln-other'
                        name='ln-other'
                        value={getByPath(formData, "links.other")}
                        onChange={e => setValue("links.other", e.target.value)}
                        validators={["matchRegexp:^.{0,150}$"]}
                        errorMessages={["Maximum length is 150 characters"]}
                      />
                    </Grid>
                  </Grid>
                </TabPanel>

                {/* Other info */}
                <TabPanel value={activeTab} index={6}>
                  <Typography className={classes.sectionHeading}>
                    Other info
                  </Typography>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='Source'
                        inputlabel='Source'
                        id='oi-source'
                        name='oi-source'
                        value={getByPath(formData, "otherInfo.source")}
                        onChange={e =>
                          setValue("otherInfo.source", e.target.value)
                        }
                        validators={["matchRegexp:^.{0,100}$"]}
                        errorMessages={["Maximum length is 100 characters"]}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='On market'
                        inputlabel='On market'
                        type='date'
                        id='oi-onmarket'
                        name='oi-onmarket'
                        value={getByPath(formData, "otherInfo.onMarket")}
                        onChange={e =>
                          setValue("otherInfo.onMarket", e.target.value)
                        }
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='Lead score'
                        inputlabel='Lead score'
                        id='oi-leadscore'
                        name='oi-leadscore'
                        type={"number"}
                        value={getByPath(formData, "otherInfo.leadScore")}
                        onChange={e =>
                          setValue("otherInfo.leadScore", e.target.value)
                        }
                        validators={[
                          "matchRegexp:^[0-9]*$",
                          "matchRegexp:^.{0,5}$",
                        ]}
                        errorMessages={[
                          "Only digits allowed",
                          "Maximum length is 5 characters",
                        ]}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputField
                        placeholder='Campaign name'
                        inputlabel='Campaign name'
                        id='oi-campaign'
                        name='oi-campaign'
                        value={getByPath(formData, "otherInfo.campaignName")}
                        onChange={e =>
                          setValue("otherInfo.campaignName", e.target.value)
                        }
                        validators={["matchRegexp:^.{0,100}$"]}
                        errorMessages={["Maximum length is 100 characters"]}
                      />
                    </Grid>
                  </Grid>
                </TabPanel>

                {/* Notes */}
                <TabPanel value={activeTab} index={7}>
                  <Typography className={classes.sectionHeading}>
                    Notes
                  </Typography>
                  <Grid container spacing={2}>
                    {[
                      {
                        key: "notes.personal",
                        id: "personalNotes",
                        label: "Personal notes",
                      },
                      {
                        key: "notes.account",
                        id: "accountNotes",
                        label: "Account notes",
                      },
                      {
                        key: "notes.meeting",
                        id: "meetingNotes",
                        label: "Meeting notes",
                      },
                      {
                        key: "notes.internal",
                        id: "internalNotes",
                        label: "Internal notes",
                      },
                    ].map(note => (
                      <Grid item xs={12} key={note.id}>
                        <EmptyTextArea
                          className='overviewTextarea'
                          placeholder={`Enter your ${note.label.toLowerCase()}`}
                          textLabel={note.label}
                          value={getByPath(formData, note.key)}
                          onChange={e => setValue(note.key, e.target.value)}
                        />
                      </Grid>
                    ))}
                  </Grid>
                </TabPanel>

                {/* Custom fields */}
                <TabPanel value={activeTab} index={8}>
                  <Typography className={classes.sectionHeading}>
                    Custom fields
                  </Typography>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={4}>
                      <InputField
                        placeholder='Custom field 1'
                        inputlabel='Custom field 1'
                        id='cf-1'
                        name='cf-1'
                        value={getByPath(formData, "customFields.custom1")}
                        onChange={e =>
                          setValue("customFields.custom1", e.target.value)
                        }
                        validators={["matchRegexp:^.{0,150}$"]}
                        errorMessages={["Maximum length is 150 characters"]}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <InputField
                        placeholder='Custom field 2'
                        inputlabel='Custom field 2'
                        id='cf-2'
                        name='cf-2'
                        value={getByPath(formData, "customFields.custom2")}
                        onChange={e =>
                          setValue("customFields.custom2", e.target.value)
                        }
                        validators={["matchRegexp:^.{0,150}$"]}
                        errorMessages={["Maximum length is 150 characters"]}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <InputField
                        placeholder='Custom field 3'
                        inputlabel='Custom field 3'
                        id='cf-3'
                        name='cf-3'
                        value={getByPath(formData, "customFields.custom3")}
                        onChange={e =>
                          setValue("customFields.custom3", e.target.value)
                        }
                        validators={["matchRegexp:^.{0,150}$"]}
                        errorMessages={["Maximum length is 150 characters"]}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <InputField
                        placeholder='Custom field 4'
                        inputlabel='Custom field 4'
                        id='cf-4'
                        name='cf-4'
                        value={getByPath(formData, "customFields.custom4")}
                        onChange={e =>
                          setValue("customFields.custom4", e.target.value)
                        }
                        validators={["matchRegexp:^.{0,150}$"]}
                        errorMessages={["Maximum length is 150 characters"]}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <InputField
                        placeholder='Custom field 5'
                        inputlabel='Custom field 5'
                        id='cf-5'
                        name='cf-5'
                        value={getByPath(formData, "customFields.custom5")}
                        onChange={e =>
                          setValue("customFields.custom5", e.target.value)
                        }
                        validators={["matchRegexp:^.{0,150}$"]}
                        errorMessages={["Maximum length is 150 characters"]}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <InputField
                        placeholder='Custom field 6'
                        inputlabel='Custom field 6'
                        id='cf-6'
                        name='cf-6'
                        value={getByPath(formData, "customFields.custom6")}
                        onChange={e =>
                          setValue("customFields.custom6", e.target.value)
                        }
                        validators={["matchRegexp:^.{0,150}$"]}
                        errorMessages={["Maximum length is 150 characters"]}
                      />
                    </Grid>
                  </Grid>
                </TabPanel>
              </div>
            </div>

            <div className={classes.actions}>
              <Button
                variant='text'
                className={classes.cancelButton}
                onClick={handleClear}>
                Clear Changes
              </Button>
              <Button variant='contained' color='primary' type='submit'>
                {id ? "Update" : "Save"}
              </Button>
            </div>
          </ValidatorForm>
        </div>
      </div>
    </Dashbard>
  );
};

export default NewProspectGeneration;
